import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { GlobalService } from './global-service.service';
import { IdleUserService } from './idle-user.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./css/pasura.css'],
    standalone: false
})
export class AppComponent {
  title = 'pasura';
  private idleUserSubscription?: Subscription;

  constructor(public router:Router, public globserv: GlobalService, private toastr: ToastrService, private http:HttpClient, private idleUserService: IdleUserService) 
  {
		console.log("Router-Url=" +this.router.url);
  }
  isUserIdle: boolean = false;
  
  ngOnInit() 
  {
  		this.updateBodyBackground();

  		this.globserv.getPasuraAction().subscribe((pasuraAction) => {
   	
   		if(pasuraAction.hasOwnProperty("msg"))
   		{
   			console.log(pasuraAction.msg.title);
   			this.showToast(pasuraAction.msg);
   		
   		}else if(pasuraAction=="LogOut")
   	    {
   	    	this.updateBodyBackground();
   	   		this.idleUserSubscription?.unsubscribe();
   	   		this.idleUserSubscription = undefined;
   	   	
   	   }else if(pasuraAction=="loginOK")
   	   	{
   	   		this.updateBodyBackground();
   	   		this.idleUserSubscription?.unsubscribe();
   	   		this.idleUserSubscription = this.idleUserService.userInactive.subscribe(isIdle => {
  					this.isUserIdle = isIdle ; 
  					this.globserv.setLogOut();
  				});
    	   }
   	   	
  		});
  	}

  ngOnDestroy()
  {
		this.idleUserSubscription?.unsubscribe();
  }

  updateBodyBackground()
  {
    if (this.globserv.Login.DBScope?.includes("_Test")) {
      document.body.style.backgroundColor = "#fff4f4";
      return;
    }

    document.body.style.backgroundColor = "";
  }
   
  
  showToast(msg)
  {
  		if (msg.typ=="success")
  		{
  			this.toastr.success(msg.txt, msg.title, { disableTimeOut: true, positionClass: "toast-top-right"});
  			
  		}else if (msg.typ=="warning")
  		{
  		  	this.toastr.success(msg.txt, msg.title, { disableTimeOut: true, positionClass: "toast-top-right"});
  		  	
  		}else{
  		
  			this.toastr.error(msg.txt, msg.title, { disableTimeOut: true, positionClass: "toast-top-right"});
  		}
  }
  
  
  
  async getAdressListe()
  {
		var data= {};
		
		try {
			this.globserv.progressSpinner=true;
      	this.downloadFile(await this.http.post("/api/v1/getAdressListe", data, {responseType: 'blob' }).toPromise());
      	
  		} catch (e) {
  		
  		   this.globserv.progressSpinner=false;
				
      	console.log(e);
  		}
			
  }
  
  async getPferdeStatistik()
  {
		var data= {};
				
		try {
      	this.globserv.progressSpinner=true;
      
      	this.downloadFile(await this.http.post("/api/v1/getPferdestatistik", data, {responseType: 'blob' }).toPromise());
      	
  		} catch (e) {
  		
  		   this.globserv.progressSpinner=true;
				
      	console.log(e);
  		}
			
  }
  	downloadFile(data) 
	{
		  this.globserv.progressSpinner=false;
        const url = window.URL.createObjectURL(data);
        console.log(JSON.stringify(this.globserv.Settings));
        window.open(url);
  	} 
  	
  	

		
  	
  	goToTransportListe()
	{
		setTimeout(() => { this.router.navigate(['transportListe']); }, 100);
 	}  
  	
  	goToTrarif(tarif)
	{
		console.log(tarif);
		
		this.router.navigate(['/tarif']);
		this.globserv.setPasuraAction('TarifGen;'+tarif);
		//this.router.navigate(['/tarif'],{queryParams:{'TarifGen':tarif}}); 
		
 	} 
 	
 	toggelPrintLogo()
 	{
 		this.globserv.Settings.PrintLogo =!this.globserv.Settings.PrintLogo;
 		localStorage.setItem("PasuraSettings", JSON.stringify(this.globserv.Settings));
 		console.log(localStorage.getItem("PasuraSettings"));
 	}
 	
 	
 	
 	makeContactDocumentTest()
	{
		//let headers = new HttpHeaders();
		//headers = headers.set('Accept', 'application/docx');
		var data= {"Contact":this.globserv.kontakt};
		
		console.log("makeContactDocument 1");
		this.http.post("/api/v1/makeContaktDocument",data, { responseType: 'blob'  })
		//this.http.post("/api/v1/makeContaktDocument",data, { responseType: 'blob'  })
            .subscribe((response: any) => {
            	 //console.log(response.headers.get('Content-Disposition'));
            	 //console.log("response.headers =", response.headers);
            	 
            	const contentDispositionHeader: string = response.headers.get('Disposition');
    				const parts: string[] = contentDispositionHeader.split(';');
    				const filename = parts[1].split('=')[1];
    				filename.replace(/"/g, '');
    				console.log(filename);
            	const blob = new Blob([response.body], { type: 'text/plain' });
            	FileSaver.saveAs(blob, "test.docx");
            	
            });FileSaver
   }	
   
   
 	makeContactDocument()
	{
		var data= {	"Contact":this.globserv.kontakt, 
						"UnterschriftName": this.globserv.Login.UnterschriftName,
						"UnterschriftTitel": this.globserv.Login.UnterschriftTitel 
					 };
		
		this.http.post("/api/v1/makeContaktDocument",data, { responseType: 'blob'  })
            .subscribe((response: any) => {
            	 
            	 var fileName = "PasuraBrief_" +  this.globserv.kontakt.ContactID +  this.globserv.getTimeStampString() + ".docx";
                FileSaver.saveAs(response, fileName);
            });
   }
   
   copySchadenfallLink()
   {
   
   	var data= {	"PolNr":this.globserv.policen[0].PolicenNr};
		
		var myresult;
		this.globserv.getBackendData("/v1/getMailTokenLink",data).subscribe(
	 
				result => 
  					myresult = result,
  					
  					err => {
  					 				console.log("Error");
  					 				console.log(err);
  					 		  },
    			
    			() => {  
    						console.log("myresult getMailTokenLink " + JSON.stringify(myresult));
    						
    						if (myresult.OK)  
    						{
							    const selBox = document.createElement('textarea');
							    selBox.style.position = 'fixed';
							    selBox.style.left = '0';
							    selBox.style.top = '0';
							    selBox.style.opacity = '0';
							    selBox.value = myresult.Link;
							    document.body.appendChild(selBox);
							    selBox.focus();
							    selBox.select();
							    document.execCommand('copy');
							    document.body.removeChild(selBox);
							    
							    
							    this.showToast({"typ":"success", "title":"Info","txt":"Der Link befindet sich nun in der Zwischenablage!"})
    						}else{
								this.showToast({"typ":"warning", "title":"Warnung","txt":"Das hat leider nicht geklappt :-("})    						
    						}
    						
    					}
		);
   }
   
   showNewPolice()
   {
		
		//console.log("showNewPolice -> " + JSON.stringify(this.globserv.policen));
				
		if (this.globserv.policen==undefined)
		{
			return true;		
		}   
		
		if ( Array.isArray(this.globserv.policen) && this.globserv.policen.length <=0 )
		{
			return true;		
		}
		
		if (JSON.stringify(this.globserv.policen)=="[{}]")
		{
			return true;		
		}
				
		
		return false;
   }	
  
    kontaktHatPolicen()
    {
    	if (this.globserv.policen==undefined) 
    	{		
    		return false;
    	}
    	
    	if (this.globserv.policen.length<1) 
    	{		
    		return false;
    	}
    	
    	if (JSON.stringify(this.globserv.policen)=="[{}]")
    	{
			false;    	
    	}
    	return true;
    }

    doTestMM()
    {
    
    	var myresult;
  		var data= Object.assign({},this.globserv.Login);
				 
		
		this.globserv.getBackendData("/v1/TestNix",data).subscribe(
		 
		result => 
		  			myresult = result,
		  			err => {
		  				console.log("Error");
		  				console.log(err);
		  			},
		       	() => {
		       		console.log("myresult " +JSON.stringify(myresult));
		       		
		       	}
		);   
  	}
}
